const degreeOptions = [
  { value: 'B.Tech', label: 'B.Tech' },
  { value: 'M.Tech', label: 'M.Tech' },
  { value: 'B.Com', label: 'B.Com' },
  { value: 'BBA', label: 'BBA' },
  { value: 'B.Sc', label: 'B.Sc' },
  { value: 'MBA', label: 'MBA' },
  { value: 'MCA', label: 'MCA' },
  { value: 'B. Arch', label: 'B. Arch' },
  { value: 'B.Design', label: 'B.Design' },
  { value: 'B.E', label: 'B.E' },
  { value: 'B.Ed', label: 'B.Ed' },
  { value: 'ITI', label: 'ITI' },
  { value: 'BA', label: 'BA' },
  { value: 'BBM', label: 'BBM' },
  {
    value: 'BFA (Bachelor of Fine Arts)',
    label: 'BFA (Bachelor of Fine Arts)'
  },
  { value: 'BFT', label: 'BFT' },
  { value: 'BHA', label: 'BHA' },
  { value: 'BHHM', label: 'BHHM' },
  { value: 'DBM', label: 'DBM' },
  { value: 'GDBM', label: 'GDBM' },
  { value: 'LLB', label: 'LLB' },
  { value: 'M. Arch', label: 'M. Arch' },
  { value: 'M. Design', label: 'M. Design' },
  { value: 'M.E', label: 'M.E' },
  {
    value: 'M.Pharm + MBA',
    label: 'M.Pharm + MBA'
  },
  { value: 'M.S', label: 'M.S' },

  { value: 'M.Sc', label: 'M.Sc' },
  { value: 'MA', label: 'MA' },
  { value: 'MBBS', label: 'MBBS' },
  { value: 'MFA (Master of Fine Arts)', label: 'MFA (Master of Fine Arts)' },
  { value: 'PG', label: 'PG' },
  { value: 'PGDBA', label: 'PGDBA' },
  { value: 'PGDM', label: 'PGDM' },
  { value: 'PGP', label: 'PGP' },
  { value: 'PGP ACM', label: 'PGP ACM' },
  { value: 'PhD', label: 'PhD' },
  { value: 'B.Pharm', label: 'B.Pharm' },
  { value: 'M.Pharm', label: 'M.Pharm' },
  { value: 'BCA', label: 'BCA' },
  { value: 'M.Com', label: 'M.Com' },
  { value: 'Other', label: 'Other' }
];

export { degreeOptions };
